import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Spinner } from "reactstrap";

import { ActivityReportData } from "./types";

/**
 * The individual records people opened — contractors, contracts, assessments,
 * sanctions entries — ranked across every content type at once, rather than one
 * type at a time.
 */
const MostViewedRecords = ({
  data,
  loading,
}: {
  data: ActivityReportData | null;
  loading: boolean;
}) => {
  const rows = data?.records || [];

  return (
    <Col xxl={6}>
      <Card className="card-height-100">
        <CardHeader className="align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Most Viewed Content</h4>
        </CardHeader>
        <CardBody>
          {loading ? (
            <div className="text-center py-5">
              <Spinner color="primary" size="sm" />
            </div>
          ) : rows.length === 0 ? (
            <div className="text-center text-muted py-5">
              No records were opened under the current filters.
            </div>
          ) : (
            <div className="table-responsive table-card">
              <table className="table align-middle table-borderless table-nowrap mb-0">
                <thead className="text-muted table-light">
                  <tr>
                    <th scope="col" style={{ width: "50%" }}>
                      Record
                    </th>
                    <th scope="col">Views</th>
                    <th scope="col">Users</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr key={`${row.contentType}-${row.entityId}`}>
                      <td>
                        <div className="text-truncate">
                          {row.pageUrl ? (
                            <Link to={row.pageUrl} className="fw-medium">
                              {row.name}
                            </Link>
                          ) : (
                            <span className="fw-medium">{row.name}</span>
                          )}
                        </div>
                        <small className="text-muted">{row.contentType}</small>
                      </td>
                      <td>{row.visits}</td>
                      <td>{row.users}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default MostViewedRecords;
